/**
 * External Dependencies
 */

import UIkit from 'uikit';
import Icons from 'uikit/dist/js/uikit-icons';
import 'rangeslider.js';
import Plyr from 'plyr';
import Select2 from 'select2';
UIkit.use(Icons);

const $ = jQuery;

const xirr = require('xirr');

$(function() {

  /* Social shares */
  function socialShares() {
    $(document).on('click', '.facebook-share-js', function(event) {
      event.preventDefault();
      var link = $(this).attr('href');
      FB.ui({
        method: 'share',
        href: link,
      }, function(response) {});

    });

    $(document).on('click', '.twitter-share-js', function(event) {
      event.preventDefault();
      var url = $(this).attr('href'),
        width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        opts = 'status=1' +
          ',width=' + width +
          ',height=' + height +
          ',top=' + top +
          ',left=' + left;

      window.open(url, 'twitter', opts);

      return false;

    });

    $(document).on('click', '.linkedin-share-js', function(event) {
      event.preventDefault();
      var url = $(this).attr('href'),
        width = 575,
        height = 400,
        left = ($(window).width() - width) / 2,
        top = ($(window).height() - height) / 2,
        opts = 'status=1' +
          ',width=' + width +
          ',height=' + height +
          ',top=' + top +
          ',left=' + left;

      window.open(url, 'linkedin', opts);

      return false;

    });
  }

  socialShares();
  /* Social shares end */

  /* Editor lightbox */
  function wiLightbox() {
    const $image = $('.wi-editor img');

    $image.each(function(key, value) {
      if ($(this).parents('a').length) return;

      if ($(this).parents('.wi-advantages-block').length) return;
      if ($(this).parents('.loan-calculator-result-box').length) return;
      if ($(this).parents('.wi-awards-block').length) return;
      if ($(this).parents('.wi-call-to-action-block').length) return;
      if ($(this).parents('.wi-our-team-block').length) return;

      const src = $(this).attr('src');
      const caption = $(this).parents('.blocks-gallery-item').length ?
        $(this).parents('.blocks-gallery-item').find('figcaption').text() :
        $(this).parents('.wp-block-image').length ?
          $(this).parents('.wp-block-image').find('figcaption').text() :
          '';

      $(this).wrap(`<a href='${src}' data-caption='${caption}' class='lightbox-js'></a>`);
    });
  }

  wiLightbox();
  /* Editor lightbox end */

  /* Slider */
  function sliderNavPosition() {
    const $slider = $('.uk-slider, .uk-slideshow');

    $slider.each(function() {
      const $imageHeight = $(this).find('ul li:first-child .wi-card-img-box').height();

      $(this).find('.uk-slidenav').css('top', $imageHeight / 2);

      setTimeout(() => {
        $(this).find('.uk-slidenav').addClass('loaded');
      }, 200);
    });
  }

  sliderNavPosition();

  setTimeout(() => {
    sliderNavPosition();
  }, 1000);

  $(window).on('resize', function() {
    sliderNavPosition();
  });
  /* Slider end */

  /* Classic editor */
  function clasicEditor() {
    const $iframe = $('.content-classic iframe');

    $iframe.each(function() {
      $(this).attr('uk-responsive', true);
    });
  }

  clasicEditor();
  /* Classic editor end */

  /* Cookie handling */
  function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function checkCookie(cname) {
    let exists = getCookie(cname);

    return (exists != "")
  }
  /* Cookie handling end */

  /* Mobile menu */
  function mobileMenu() {
    const $burgerBtn = $('#burgerBtn');
    const $mobileMenu = $('#mobileMenu');
    const $mobileMenunav = $('.mobile-menu-nav');

    $burgerBtn.on('click', function(e) {
      e.preventDefault();

      $(this).toggleClass('open');
      $mobileMenu.toggleClass('open');
      $('body, html').toggleClass('disable-scroll');
    });

    $mobileMenunav.find('li.has-child > a').on('click', function(e) {
      e.preventDefault();

      $(this).parent('li').toggleClass('active');
      $(this).siblings('ul').slideToggle();
    });
  }

  mobileMenu();
  /* Mobile menu end */

  /* Live search */
  function liveSearch() {
    const $searchField = $('#searchField');
    const $searchFieldClear = $('#searchFieldClear');

    $searchField.on('change paste keyup', function() {
      const keyword = $(this).val();
      clearTimeout(this.searchTimeout);

      if (keyword.length > 0) {
        $searchFieldClear.fadeIn();
      } else {
        $searchFieldClear.fadeOut();
      }

      if (keyword.length > 2) {
        this.searchTimeout = setTimeout(() => {
          runSearch(keyword);
        }, 500);
      }

    });

    function runSearch(keyword = '') {
      const $searchModalAllRes = $('#searchModalAllRes');
      const $searchModalResCount = $('#searchModalResCount');
      const $searchModalResultItems = $('#searchModalResultItems');
      const $searchModalResultNotFound = $('#searchModalResultNotFound');
      const $wiLoader = $('.wi-loader-box');

      $wiLoader.show();

      $.ajax({
        type: "get",
        url: `/api/wi/sr/v1/autocomplete?keyword=${keyword}&key=${config.api_key}`,
        success: function(response) {
          const found_posts = response.data?.found_posts ? response.data.found_posts : 0;
          $searchModalResultItems.empty();
          $searchModalResultItems.css('min-height', 0);

          $wiLoader.hide();

          if (found_posts) {
            // console.log(response.data.posts);
            $searchModalResultNotFound.hide();

            response.data.posts.map((item) => {
              const elem = `
                <div class="search-modal-result-item">
                  <div class="uk-grid" uk-grid>
                    <div class="uk-width-auto">
                      <img src="${item.image.src.thumbnail}" alt="${item.image.alt}" class="search-modal-result-item-img" />
                    </div>
                    <div class="uk-width-expand">
                      <a href="${item.url}" class="search-modal-result-item-title">${item.title}</a>
                      <span class="search-modal-result-item-tag">${item.search_term.names}</span>
                    </div>
                  </div>
                </div>
              `;

              $searchModalResultItems.append(elem);
            });

            $searchModalResultItems.show();
          } else {
            $searchModalResultNotFound.show();
          }

          $searchModalAllRes.show();
          $searchModalResCount.html(`(${found_posts})`);
          $searchModalAllRes.children('a').attr('href', (window.language == 'en' ? '/en/?s=' : '/?s=') + keyword);
        }
      });
    }

    $searchFieldClear.on('click', function() {
      $searchFieldClear.fadeOut();
      $searchField.val('').trigger('change');
    });
  }

  liveSearch();
  /* Live search end */

  /* Footer accordion */
  function footer() {
    $('.wi-footer-col-title').on('click', function(e) {
      e.preventDefault();

      if (window.matchMedia('(max-width: 959px)').matches) {
        $(this).siblings('.wi-footer-list').slideToggle();
      } else {
        $(this).siblings('.wi-footer-list').fadeIn();
      }
    });
  }

  footer()
  /* Footer accordion end */

  /* Branch map */
  function locationBlock() {

    if ($(".branch-map-markers").length === 0) return;

    let time = 0;

    $('.branch-map-markers path').each(function() {
      setTimeout(() => {
        $(this).addClass('active bounceInDown');
      }, time);

      time += 100;
    });
  }

  function locationBlockViewportCheck() {

    if ($("#branchMap").length === 0) return;

    const $branchMap = $('#branchMap');

    UIkit.scrollspy($branchMap, {
      offset: 200
    });

    $branchMap.on('inview', function() {
      locationBlock();
    });
  }

  locationBlockViewportCheck();

  $('#branchModal').on("beforeshow", function() {
    $('#branchTable').css('min-height', 0);
  });

  function runLocationSearch(keyword = '', location = '') {
    const $branchList = $('#branchList');
    const $branchNotFound = $('#branchNotFound');
    const $branchTable = $('#branchTable');
    const $branchTableHeader = $('#branchTableHeader');
    const $wiLoader = $('.wi-loader-box');
    const language = config.language;

    $branchTable.css('min-height', 0);
    $wiLoader.show();

    $.ajax({
      type: "get",
      url: `/api/wi/location/v1/search?location=${location}&type=finance&keyword=${keyword}&language=${language}&key=${config.api_key}`,
      success: function(response) {
        $branchList.empty();
        $wiLoader.hide();

        if (response.data.results && response.data.results.length > 0) {
          $branchNotFound.hide();
          $branchTableHeader.show();

          response.data.results.map((item) => {
            const elem = `
              <div class="uk-grid" uk-grid>

                <div class="uk-width-expand uk-flex uk-flex-column uk-flex-center">

                  <a href="https://maps.google.com/?q=${item.vicinity}" target="_blank">
                    <p class="m-v-xs-0 uk-text-emphasis">${item.vicinity}</p>
                  </a>

                  <div class="uk-hidden@m">
                    <div class="branch-table-workdays mobile">

                      ${shortenWeekdays(item.weekday_text).map((weekday) => `
                        <p>${weekday.date}</p>
                      `).join("")}

                    </div>
                  </div>
                </div>

                <div class="uk-width-auto uk-flex uk-flex-middle uk-visible@m">
                  <div class="branch-table-col-medium">
                    <div class="branch-table-workdays">

                      ${shortenWeekdays(item.weekday_text).map((weekday) => `
                        <p>${weekday.date}</p>
                      `).join("")}

                    </div>
                  </div>
                </div>

                <div class="uk-width-auto uk-flex uk-flex-middle uk-text-right">
                  <div class="branch-table-col-small">
                    <a href="https://maps.google.com/?q=${item.vicinity}" target="_blank" class="uk-button uk-button-secondary branch-map-link-btn">
                      <img src="${config.resources_url}images/marker-red.svg" alt="Icon" />
                      <span>${window.see_on_map_text}</span>
                    </a>
                  </div>
                </div>

              </div>

              <hr />
            `;

            $branchList.append(elem);
          });

          $branchList.show();
        } else {
          $branchTableHeader.hide();
          $branchNotFound.show();
          $branchTable.css('min-height', 0);
        }
      }
    });
  }

  function shortenWeekdays(weekdays = []) {
    const weekdaysShort = [];

    weekdays.map((item, index) => {
      const obj = {};

      obj.day = item.split(': ')[0];
      obj.date = item.split(': ')[1].replace(' AM', '').replace(' PM', '').replace(/\s/g, '');

      weekdaysShort[index] = obj;
    });

    function groupBy(arr, criteria) {
      const newObj = arr.reduce(function(acc, currentValue) {
        if (!acc[currentValue[criteria]]) {
          acc[currentValue[criteria]] = [];
        }
        acc[currentValue[criteria]].push(currentValue);
        return acc;
      }, {});
      return newObj;
    }

    const weekdaysShortGrouped = groupBy(weekdaysShort, "date");
    const weekdaysShortGroupedParsed = [];

    Object.keys(weekdaysShortGrouped).map((key, index) => {
      const item = weekdaysShortGrouped[key];
      const obj = {};

      if (item[0].date == 'Closed') {
        item[0].date = window.not_working_text;
      }

      if (item.length > 0) {
        obj.date = item[0].day + '-' + item[item.length - 1].day + ' / ' + item[0].date;
      } else {
        obj.date = item[0].day + ' / ' + item[0].date;
      }

      weekdaysShortGroupedParsed[index] = obj;
    });

    // console.log(weekdaysShortGroupedParsed);

    return weekdaysShortGroupedParsed;
  }

  function branchAutoComplete() {
    let autocomplete;

    autocomplete = new google.maps.places.Autocomplete(document.querySelector('#branchField'), {
      componentRestrictions: {
        country: ["ge"]
      },
      fields: ["formatted_address", "geometry"],
      types: ['(cities)'],
    });

    autocomplete.addListener("place_changed", fillInAddress);

    function fillInAddress() {
      // Get the place details from the autocomplete object.
      const place = autocomplete.getPlace();
      const address = place.formatted_address;
      const lat = place.geometry.location.lat();
      const lng = place.geometry.location.lng();
      const location = lat + ',' + lng;

      runLocationSearch(address, location);
    }
  }

  if (window.hasOwnProperty('google')) {
    google.maps.event.addDomListener(window, 'load', branchAutoComplete);
  }

  setTimeout(() => {
    branchAutoComplete();
  }, 1000);

  /* Branch map end */

  /* Currency */
  function loadCurrency() {
    const $currencyData = $('#currencyData');
    const $currencyLoader = $('#currencyLoader');
    const currencyItem = (item) => {
      return `
        <div class="uk-grid" uk-grid>
          <div class="uk-width-expand">
            <div class="uk-grid" uk-grid>
              <div class="uk-width-auto">
                <img src="${item.logo}" class="currency-table-img" />
              </div>
              <div class="uk-width-expand uk-flex uk-flex-middle">
                <div>
                  <p class="m-v-xs-0 uk-text-emphasis">${item.name}</p>
                </div>
              </div>
            </div>
          </div>
          <div class="uk-width-auto uk-flex uk-flex-middle uk-visible@s">
            <div class="uk-flex uk-flex-middle currency-table-col-medium">
              <span class="uk-text-emphasis">${Number(item.NBGRate).toFixed(4)}</span>
              ${`<span uk-icon="triangle-${(item.NBGRateDiff < 0) ? 'down' : 'up'}" class="uk-icon uk-text-${(item.NBGRateDiff < 0) ? 'danger' : 'success'} m-l-sm-8"></span>`}
            </div>
          </div>
          <div class="uk-width-auto uk-flex uk-flex-middle">
            <div class="uk-flex uk-flex-middle currency-table-col-small">
              <span class="uk-text-emphasis">${Number(item.AMOUNT_BUY).toFixed(4)}</span>
            </div>
          </div>
          <div class="uk-width-auto uk-flex uk-flex-middle">
            <div class="uk-flex uk-flex-middle currency-table-col-small">
              <span class="uk-text-emphasis">${Number(item.AMOUNT_SELL).toFixed(4)}</span>
            </div>
          </div>
        </div>
      `;
    };

    $.ajax({
      type: "get",
      url: (JSON.parse(window.rate_api_link) === "") ? "https://crystal.ge/api/wi/rate/v1/cryst?key=52ef35743f3c4f5027d82f051c258241" : JSON.parse(window.rate_api_link),
      success: function(response) {
        try {
          const apiData = response.success ? JSON.parse(response.data).data.CurrencyRate : [];
          const currencies = JSON.parse(window.currencies);
          const currenciesToLoad = window.currenciesToLoad;

          currencies.map((item, index) => {

            const currencyFoundItem = apiData.filter((apiItem) => apiItem.ISO == item.iso);

            currencyFoundItem.AMOUNT_BUY = 1;
            currencyFoundItem.AMOUNT_SELL = 1;

            currencies[index] = {
              ...item,
              ...currencyFoundItem[0]
            };
          });

          window.currencies = currencies;
          if (!currenciesToLoad) {
            changeCurrencyRateInfo();
          }

          $currencyData.empty();
          $currencyLoader.hide();

          if (currencies && !currenciesToLoad) {
            currencies.map((item, index) => {
              if (item.iso != 'GEL' && ((window.front_page && index < 4) || !window.front_page)) {
                $currencyData.append(currencyItem(item));
              }
            });
            $currencyData.show();
          } else if (currencies && currenciesToLoad) {
            currenciesToLoad.map((item) => {
              currencies.map((currencie) => {
                if (item === currencie["iso"]) {
                  $currencyData.append(currencyItem(currencie));
                }
              });
            });
            $currencyData.show();
          }
        } catch (e) {
          console.warn('loadCurrency', e);
        }
      }
    });
  }

  loadCurrency();
  /* Currency end */

  /* Calculator */
  function calculator() {

    $(".calculator-select").each(function(index, element) {
      if ($(this).length === 0) return;

      $(this).select2({
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        dropdownCssClass: 'select2-calculator-dropdown',
        width: '100%',
      });

      $(this).on('select2:select', function(e) {
        changeCurrencyRateInfo();
        convertCurrency();
      });
    });

    const $calculatorInputFrom = $('.calculator-input-from-js');

    $('.calculator-switcher-js').on('click', function() {
      const savedCalculatorSelectFrom = $(this).parents('.calculator-box').find('.calculator-select-from-js').val();
      const savedCalculatorSelectTo = $(this).parents('.calculator-box').find('.calculator-select-to-js').val();

      $(this).parents('.calculator-box').find('.calculator-select-to-js').val(savedCalculatorSelectFrom).trigger("change");
      $(this).parents('.calculator-box').find('.calculator-select-from-js').val(savedCalculatorSelectTo).trigger("change");

      changeCurrencyRateInfo();
      convertCurrency();
    });

    $calculatorInputFrom.on('keyup copy', function() {
      convertCurrency();
    });

  }

  function convertCurrency() {
    const $calculatorSelectFrom = $('.calculator-select-from-js');
    const $calculatorSelectTo = $('.calculator-select-to-js');
    const $calculatorInputFrom = $('.calculator-input-from-js');
    const $calculatorInputTo = $('.calculator-input-to-js');
    let currencyFrom = window.currencies.filter((item) => item.iso == $calculatorSelectFrom.val());
    let currencyTo = window.currencies.filter((item) => item.iso == $calculatorSelectTo.val());

    let currencyCount = currencyFrom[0].iso == 'RUB' ?
      100 :
      currencyFrom[0].iso == 'AMD' ?
        1000 :
        currencyFrom[0].iso == 'ILS' || currencyFrom[0].iso == 'PLN' ?
          10 :
          1;

    if ($calculatorSelectFrom.val() == 'GEL') {
      let val = Number($calculatorInputFrom.val() / currencyTo[0].AMOUNT_SELL).toFixed(4);

      if ($calculatorSelectTo.val() == 'RUB') {
        val = (val * 100).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'AMD') {
        val = (val * 1000).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'ILS' || $calculatorSelectTo.val() == 'PLN') {
        val = (val * 10).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        val = currencyCount;
      }

      $calculatorInputTo.val(val);
    } else if ($calculatorSelectTo.val() == 'GEL') {
      let val = Number($calculatorInputFrom.val() * currencyFrom[0].AMOUNT_BUY).toFixed(4);

      if ($calculatorSelectFrom.val() == 'RUB') {
        val = (val / 100).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == 'AMD') {
        val = (val / 1000).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == 'ILS' || $calculatorSelectFrom.val() == 'PLN') {
        val = (val / 10).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        val = currencyCount;
      }

      $calculatorInputTo.val(val);
    } else {
      let val = Number((currencyFrom[0].AMOUNT_BUY / currencyTo[0].AMOUNT_SELL) * $calculatorInputFrom.val());
      if ($calculatorSelectFrom.val() == 'RUB') {
        val = (val / 100);
      }
      if ($calculatorSelectFrom.val() == 'AMD') {
        val = (val / 1000);
      }
      if ($calculatorSelectFrom.val() == 'ILS' || $calculatorSelectFrom.val() == 'PLN') {
        val = (val / 10);
      }
      if ($calculatorSelectTo.val() == 'RUB') {
        val = (val * 100);
      }
      if ($calculatorSelectTo.val() == 'AMD') {
        val = (val * 1000);
      }
      if ($calculatorSelectTo.val() == 'ILS' || $calculatorSelectTo.val() == 'PLN') {
        val = (val * 10);
      }
      val = val.toFixed(4);

      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        val = currencyCount;
      }

      $calculatorInputTo.val(val);
    }
  }

  function changeCurrencyRateInfo() {
    const $calculatorSelectFrom = $('.calculator-select-from-js');
    const $calculatorSelectTo = $('.calculator-select-to-js');
    let currencyFrom = window.currencies.filter((item) => item.iso == $calculatorSelectFrom.val());
    let currencyTo = window.currencies.filter((item) => item.iso == $calculatorSelectTo.val());

    let currencyCount = currencyFrom[0].iso == 'RUB' ?
      100 :
      currencyFrom[0].iso == 'AMD' ?
        1000 :
        currencyFrom[0].iso == 'ILS' || currencyFrom[0].iso == 'PLN' ?
          10 :
          1;

    if (currencyFrom[0].iso == 'GEL') {
      let rate = Number(1 / currencyTo[0].AMOUNT_SELL).toFixed(4);

      if ($calculatorSelectTo.val() == 'RUB') {
        rate = (rate * 100).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'AMD') {
        rate = (rate * 1000).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'ILS' || $calculatorSelectTo.val() == 'PLN') {
        rate = (rate * 10).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        rate = 1;
      }

      $('.calculator-currency-rate-js').text(1 + ' ' + currencyFrom[0].iso + ' = ' + rate + ' ' + currencyTo[0].iso);
    } else if (currencyTo[0].iso == 'GEL') {
      let rate = Number(currencyFrom[0].AMOUNT_BUY).toFixed(4);

      if ($calculatorSelectTo.val() == 'RUB') {
        rate = (rate / 100).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'AMD') {
        rate = (rate / 1000).toFixed(4);
      }

      if ($calculatorSelectTo.val() == 'ILS' || $calculatorSelectTo.val() == 'PLN') {
        rate = (rate / 10).toFixed(4);
      }

      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        rate = currencyCount;
      }

      $('.calculator-currency-rate-js').text(currencyCount + ' ' + currencyFrom[0].iso + ' = ' + rate + ' ' + currencyTo[0].iso);
    } else {
      let rate = Number(currencyFrom[0].AMOUNT_BUY / currencyTo[0].AMOUNT_SELL);

      if ($calculatorSelectTo.val() == 'RUB') {
        rate = (rate * 100);
      }

      if ($calculatorSelectTo.val() == 'AMD') {
        rate = (rate * 1000);
      }

      if ($calculatorSelectTo.val() == 'ILS' || $calculatorSelectTo.val() == 'PLN') {
        rate = (rate * 10);
      }
      rate = (rate).toFixed(4);
      if ($calculatorSelectFrom.val() == $calculatorSelectTo.val()) {
        rate = currencyCount;
      }

      $('.calculator-currency-rate-js').text(currencyCount + ' ' + currencyFrom[0].iso + ' = ' + rate + ' ' + currencyTo[0].iso);
    }
  }

  calculator();
  /* Calculator end */

  /* Loan calculator */
  function loanCalculator() {
    const $loanCalcPercentSlider = $('#loanCalcPercentSlider');
    const $loanCalcPercentField = $('#loanCalcPercentField');
    const $loanCalcMonthSlider = $('#loanCalcMonthSlider');
    const $loanCalcMonthField = $('#loanCalcMonthField');
    const $loanCalcMoneySlider = $('#loanCalcMoneySlider');
    const $loanCalcMoneyField = $('#loanCalcMoneyField');
    const $loanMonth = $('#loanMonth');
    const $loanMoney = $('#loanMoney');
    const $loanCalcMoneyCurrency = $('#loanCalcMoneyCurrency');
    const $currencySign = $('.currency-sign');
    const $loanPercentYearly = $('#loanPercentYearly');
    $loanPercentYearly.html($loanCalcMoneyCurrency.attr('data-rate'));
    let loanCalculateInterval = null;
    clearInterval(loanCalculateInterval);

    $loanCalcMoneyCurrency.on('select2:select', function(e) {
      const value = $loanCalcMoneyCurrency.find('option:Selected').attr('data-rate');
      const sign = $loanCalcMoneyCurrency.find('option:Selected').attr('data-sign');

      $currencySign.html(sign);

      $loanPercentYearly.children('span').html(value);
      $loanCalcPercentField.val(value);
      $loanCalcPercentSlider.val(value);
      $loanCalcPercentSlider.rangeslider('update', true);
    });

    $loanCalcMoneySlider.rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider',
      disabledClass: 'rangeslider--disabled',
      horizontalClass: 'rangeslider--horizontal',
      verticalClass: 'rangeslider--vertical',
      fillClass: 'rangeslider__fill',
      handleClass: 'rangeslider__handle',
      onSlideEnd: function(position, value) {
        $loanCalcMoneyField.val(value);
        $loanMoney.children('span').html(value);
      }
    });

    $loanCalcMoneyField.on('keyup paste', function() {
      $loanCalcMoneySlider.val($(this).val());
      $loanMoney.children('span').html($(this).val());
      $loanCalcMoneySlider.rangeslider('update', true);
    });

    $loanCalcPercentSlider.rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider',
      disabledClass: 'rangeslider--disabled',
      horizontalClass: 'rangeslider--horizontal',
      verticalClass: 'rangeslider--vertical',
      fillClass: 'rangeslider__fill',
      handleClass: 'rangeslider__handle',
      onSlideEnd: function(position, value) {
        $loanCalcPercentField.val(value);
        $loanPercentYearly.children('span').html(value);
      }
    });

    $loanCalcPercentField.on('keyup paste', function() {
      $loanCalcPercentSlider.val($(this).val());
      $loanPercentYearly.children('span').html($(this).val());
      $loanCalcPercentSlider.rangeslider('update', true);
    });

    $loanCalcMonthSlider.rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider',
      disabledClass: 'rangeslider--disabled',
      horizontalClass: 'rangeslider--horizontal',
      verticalClass: 'rangeslider--vertical',
      fillClass: 'rangeslider__fill',
      handleClass: 'rangeslider__handle',
      onSlideEnd: function(position, value) {
        $loanCalcMonthField.val(value);
        $loanMonth.children('span').html(value);
      }
    });

    $loanCalcMonthField.on('keyup paste', function() {
      $loanCalcMonthSlider.val($(this).val());
      $loanMonth.children('span').html($(this).val());
      $loanCalcMonthSlider.rangeslider('update', true);
    });

    const calculateLoan = function() {
      const $loanFullMoney = $('#loanFullMoney span');
      const $effectivePercent = $('#effectivePercent span');
      let loanMonth = document.querySelector("#loanMonth span").textContent;
      let loanMoney = document.querySelector("#loanMoney span").textContent;
      let loanPercentYearly = Number(document.querySelector("#loanPercentYearly span").textContent) / 100 / 12;
      let moneyToPay = 0;

      moneyToPay = -PMT(Number(loanPercentYearly), Number(loanMonth), Number(loanMoney));
      moneyToPay = Number.isInteger(Math.round(moneyToPay)) ? moneyToPay.toFixed(2) : 0;

      $loanFullMoney.html(moneyToPay);
      $effectivePercent.html(calculateXirr(Number(loanMoney), Number(moneyToPay), Number(loanMonth)));
    }

    const PMT = function(ir, np, pv, fv, type) {
      /*
       * ir   - interest rate per month
       * np   - number of periods (months)
       * pv   - present value
       * fv   - future value
       * type - when the payments are due:
       *        0: end of the period, e.g. end of month (default)
       *        1: beginning of period
       */
      var pmt, pvif;

      fv || (fv = 0);
      type || (type = 0);

      if (ir === 0)
        return -(pv + fv) / np;

      pvif = Math.pow(1 + ir, np);
      pmt = -ir * pv * (pvif + fv) / (pvif - 1);

      if (type === 1)
        pmt /= (1 + ir);

      return pmt;
    }

    const calculateXirr = function(fullAmount, monthlyAmount, months) {

      if (!monthlyAmount) return;

      fullAmount = fullAmount - ((fullAmount * 2) / 100);

      const dates = [];
      dates.push({
        amount: fullAmount,
        when: new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDay()),
      });

      for (let index = 0; index < months; index++) {
        dates.push({
          amount: -Math.abs(monthlyAmount),
          when: new Date(new Date().getFullYear(), new Date().getMonth() + index + 1, new Date().getDay())
        });
      }

      let rate = xirr(dates);

      rate = (rate * 100).toFixed(2);

      return rate;

    }

    loanCalculateInterval = setInterval(() => {
      calculateLoan();
    }, 1000);
  }

  if ($('#loanCalcMoneySlider').length > 0 && $('body').hasClass('single')) {
    loanCalculator();
  }

  if ($('.page-template-default').length > 0) {
    loanCalculator();
  }

  $('#loanCalculatorModal').on("shown", function() {
    if ($('#loanCalcMoneySlider').length > 0) {
      loanCalculator();
    }
  });
  /* Loan calculator end */

  /* WI Commons */
  function wiCommons() {
    const $wiInputBox = $('.wi-input-box');
    const $wiInputClose = $('.wi-input-close');

    $wiInputBox.each(function() {
      const that = $(this);

      that.find('.wi-input').on('keyup paste', function() {
        if ($(this).val().length > 0) {
          that.find('.wi-input-close').fadeIn();
        } else {
          that.find('.wi-input-close').fadeOut();
        }
      });
    });

    $wiInputClose.on('click', function() {
      $(this).fadeOut();
      $(this).parents('.wi-input-box').find('.wi-input').val('').trigger('change');
    });

    $('.wi-wysiwyg-js').find('ul').addClass('uk-list uk-list-bullet uk-list-secondary');
    $('.gfield_radio input[type="radio"]').addClass('uk-radio');
    $('input[type="checkbox"]').addClass('uk-checkbox');

    $('.wi-select-box').addClass('active');
    $('.wi-select-box .gfield_select').addClass('uk-select wi-select');
    $('.wi-select-box .gfield_select').parent('div').siblings('.gfield_label').addClass('wi-select-label');
    $('.wi-select-box .gfield_select').parent('div').siblings('.gfield_label').removeClass('gfield_label');

    $('.gfield_select').addClass('uk-select');

    $(document).on('gform_confirmation_loaded', function() {
      location.href = window.location.href + "?sent=1";
    });

    if (window.formSent == '1') {
      UIkit.notification(`<svg class="notif-icon" width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.5 0C5.8832 0 0.5 5.3832 0.5 12C0.5 18.6168 5.8832 24 12.5 24C19.1168 24 24.5 18.6168 24.5 12C24.5 5.3832 19.1168 0 12.5 0ZM12.5 21.8182C7.08618 21.8182 2.68182 17.4137 2.68182 12C2.68182 6.58625 7.08618 2.18182 12.5 2.18182C17.9138 2.18182 22.3182 6.58625 22.3182 12C22.3182 17.4137 17.9137 21.8182 12.5 21.8182Z" fill="#FF5440"/>
      <path d="M17.0001 8.49259L10.8289 14.6637L8.00048 11.8353C7.57451 11.4093 6.88375 11.4092 6.45771 11.8352C6.03167 12.2612 6.03167 12.9519 6.45771 13.378L10.0574 16.9778C10.262 17.1824 10.5395 17.2974 10.8288 17.2974C10.8289 17.2974 10.8288 17.2974 10.8289 17.2974C11.1182 17.2974 11.3956 17.1824 11.6002 16.9779L18.5428 10.0354C18.9689 9.60938 18.9689 8.91869 18.5428 8.49266C18.1168 8.06662 17.4261 8.06655 17.0001 8.49259Z" fill="#FF5440"/>
      </svg>${window.form_sent_text}`, {
        pos: 'bottom-center',
        timeout: 3000
      });
    }
  }

  wiCommons()
  /* WI Commons end */

  /* Career */
  function career() {

    $('.vacancy-search-field-js, .vacancy-department-select-js, .vacancy-type-select-js, .vacancy-city-select-js').on('keyup paste change', function() {
      const searchFieldVal = $('.vacancy-search-field-js').val();
      const departmentVal = $('.vacancy-department-select-js').val();
      const typeVal = $('.vacancy-type-select-js').val();
      const cityVal = $('.vacancy-city-select-js').val();

      $('.vacancy-table-card-js').each(function() {
        if (
          ($(this).attr('data-department').includes(departmentVal) || !departmentVal) &&
          ($(this).attr('data-type').includes(typeVal) || !typeVal) &&
          ($(this).attr('data-city').includes(cityVal) || !cityVal) &&
          ($(this).attr('data-title').includes(searchFieldVal) || !searchFieldVal)
        ) {
          $(this).show();

          $('.vacancy-table-js').removeClass('uk-hidden');
        } else {
          $(this).hide();
        }
      });

      if (!$(".vacancy-table-card-js").is(":visible")) {
        $('.vacancy-not-found-js').removeClass('uk-hidden');
        $('.vacancy-table-js').addClass('uk-hidden');
      } else {
        $('.vacancy-not-found-js').addClass('uk-hidden');
        $('.vacancy-table-js').removeClass('uk-hidden');
      }
    });

  }

  career()
  /* Career end */

  /* Player */
  function player() {
    const controls = [
      'play',
      'progress',
      'duration',
      'mute',
      'volume',
      'fullscreen',
    ];

    $('.wp-block-video').each(function() {
      new Plyr($(this).find('video'), {
        controls,
      });
    });

    $('.wp-block-audio').each(function() {
      new Plyr($(this).find('audio'));
      $(this).attr('controlsList', 'nodownload');
    });

  }

  player()
  /* Player end */

  /* Faq */
  function faq() {
    const $faqSearchField = $('.faq-search-field');
    const $faqQuestionsList = $('#faqQuestionsList');
    const $faqResultNotFound = $('#faqResultNotFound');

    $faqSearchField.on('keyup paste change', function() {
      const value = $(this).val();

      $faqQuestionsList.find('li').each(function() {
        if (
          $(this).text().includes(value)
        ) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });

      if ($faqQuestionsList.children('li').is(':visible')) {
        $faqResultNotFound.addClass('uk-hidden');
      } else {
        $faqResultNotFound.removeClass('uk-hidden');
      }
    });
  }

  faq()
  /* Faq end */

  /* Read-more */
  function handleReadMore() {
    if ($('.style--read-more').length) {
      $('.wi-our-team-block--member-read-more a').on('click', function() {
        $(this).parent('.wi-our-team-block--member-read-more').find('a').toggleClass('uk-hidden');
        $(this).parents('.wi-our-team-block--member').toggleClass('read-more-active');
      });
    }
  }

  handleReadMore()
  /* Read-more end */

  function onTidioChatApiReady() {

    $('#chat-link').on('click', function(e) {
      e.preventDefault();
      tidioChatApi.open();
    });

  }
  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  } else {
    document.addEventListener("tidioChat-ready", onTidioChatApiReady);
  }

  /*
   * Calculator Block Selects
   * */
  const element = document.getElementById('benefit_calculator');

  if (element) {
    $('.wi-calculator__select').select2({
      minimumResultsForSearch: Infinity // Hides the search bar
    });

    const interest = document.querySelectorAll('interest');

    // Deposit Input
    const amountNumber = document.getElementById('amountNumber');

    // Selects
    const selectDeposit = document.getElementById('wi-calculator__deposit');
    const selectDuration = document.getElementById('wi-calculator__duration');
    const selectPaymentType = document.getElementById('wi-calculator__benefit-withdrawal-period');
    const currencyRadios = document.querySelectorAll('input[name="currency"]');

    // Values
    const moneyAfter = document.querySelector('#money-after');
    const benefit = document.querySelector('#benefit');
    const percentContainer = document.querySelector('#percent');
    const effectivePercent = document.querySelector('#effective_percent');

   // Restrict input to numeric values, allowing one dot for decimals
   amountNumber.onkeydown = (event) => {
    // Allow numbers, Backspace, one dot (.), and navigation keys
    if (
      isNaN(event.key) && 
      event.key !== 'Backspace' && 
      event.key !== '.' && 
      event.key !== 'ArrowLeft' && 
      event.key !== 'ArrowRight' && 
      event.key !== 'Delete'
    ) {
      event.preventDefault();
    }
  
    // Prevent more than one dot in the input
    if (event.key === '.' && amountNumber.value.includes('.')) {
      event.preventDefault();
    }
  };

    // Exchange rates
    const exchangeRates = {
      USD: window.usdRate, 
      EUR: window.eurRate 
    };

    // Function to determine valid range based on selected currency
    function getValidRangeForCurrency(currency) {
      const gelMin = 100000;
      const gelMax = 3000000;

      if (currency === "GEL") {
        return { min: gelMin, max: gelMax };
      } else if (currency === "USD") {
        return { min: (gelMin / exchangeRates.USD).toFixed(0), max: (gelMax / exchangeRates.USD).toFixed(0) };
      } else if (currency === "EUR") {
        return { min: (gelMin / exchangeRates.EUR).toFixed(0), max: (gelMax / exchangeRates.EUR).toFixed(0) };
      }
      return { min: 0, max: 0 }; // Default fallback
    }

    // Function to check if the amount is valid
    function isAmountValid() {
      let currencyValues = "GEL";
      for (const radio of currencyRadios) {
        if (radio.checked) {
          currencyValues = radio.value;
          break;
        }
      }
  
      const { min, max } = getValidRangeForCurrency(currencyValues);
      const amount = parseFloat(amountNumber.value);
  
      return amount >= min && amount <= max;
    }

    // Function to run calculate if amount is valid
    function calculateIfValid() {
      if (isAmountValid()) {
        calculate(); // Call the calculate function only if the amount is valid
      }
    }

    function calculate() {
      const contributionAmount = parseFloat(amountNumber.value) || 0;
      const durationValue = parseInt(selectDuration.value);
      const DepositValue = parseInt(selectDeposit.value);
      const paymentType = selectPaymentType.value;
      const data = paymentType === "month" ? window.interestMonth : window.interestYear;

      let currencyValues = "GEL";
      for (const radio of currencyRadios) {
        if (radio.checked) {
          currencyValues = radio.value;
          break; // Break the loop when a checked radio button is found
        }
      }

      function countDaysFromToday(months) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const futureDate = new Date(today.getFullYear(), today.getMonth() + months, today.getDate());
        const timeDifference = futureDate - today;
        const daysDifference = timeDifference / (1000 * 3600 * 24);

        return daysDifference;
      }

      function showValue() {
        let percent = checkAndPrintNominal(data, durationValue, DepositValue, currencyValues, paymentType);
        const interestValue = percent / 100;
        const termValue = countDaysFromToday(durationValue); // Use countDaysFromToday to get days
        const compoundingPeriods = paymentType === "month" ? 12 : 4;

        const effectiveAnnualPercent = returnArrayForXirr(new Date(), durationValue, percent, 100000, paymentType === "month" ? 0 : 1);
        var rate = (xirr(effectiveAnnualPercent, 0.1) * 100).toFixed(2);
        let finalNumber = contributionAmount * (1 + interestValue * (termValue / 365));

        percentContainer.textContent = percent + " %";

        moneyAfter.textContent = finalNumber.toFixed(2);
        benefit.textContent = (finalNumber - contributionAmount).toFixed(2);
        effectivePercent.textContent = rate + " %";
      }

      function checkAndPrintNominal(data, selectDurationValue, selectDepositValue, currencyValues, paymentType) {
        for (const row of data) {
          // Parse the range string into numeric values
          const [minDuration, maxDuration] = row.benefit_duration.split('-').map(Number);

          // Check if selectDuration falls within the range
          if (!(selectDurationValue >= minDuration && selectDurationValue <= maxDuration))
            continue;

          // Checks Type
          if (!((row.benefit_type === "დახურული" && selectDepositValue === 0) || (row.benefit_type === "ღია" && selectDepositValue === 1)))
            continue;

          // Checks Currency
          if (currencyValues === "GEL")
            return parseFloat(row.nominal_gel);
          else if (currencyValues === "USD")
            return parseFloat(row.nominal_usd);
          else
            return parseFloat(row.nominal_eur);
        }
      }

      function returnArrayForXirr(today, n, percent, deposit, type)
      {
        const datesArray = [];
        let currentDate = new Date(today);
        let firstDate = new Date(today);

        datesArray.push({
          when: new Date(currentDate),
          amountMonthly: -deposit,
          amountYearly: -deposit
        });

        for (let i = 0; i < n; i++) {
          const previousDate = new Date(currentDate);

          // Add months to the current date
          currentDate.setMonth(currentDate.getMonth() + 1);

          // Adjust the day if it exceeds the number of days in the new month
          if (currentDate.getDate() < previousDate.getDate()) {
            currentDate.setDate(0); // Go to the last day of the previous month
          }

          // Calculate the number of days between the current and previous dates
          const daysDiff = Math.floor((currentDate - previousDate) / (1000 * 60 * 60 * 24));

          if (n - 1 !== i) {
            // Save the future date and the days difference in the array
            datesArray.push({
              when: new Date(currentDate),
              amountMonthly: deposit * percent * daysDiff / 365 / 100,
              amountYearly: 0,
            });
          } else {
            datesArray.push({
              when: new Date(currentDate),
              amountMonthly: deposit * percent * daysDiff / 365 / 100 + deposit,
              amountYearly: Number((deposit * percent / 100 / 365 * Math.floor((currentDate - firstDate) / (1000 * 60 * 60 * 24))).toFixed(0)) + deposit,
            });
          }
          // Update the previous date for the next iteration
          today = new Date(currentDate);
        }
        let transformedArray = 0;

        if (type === 0) {
          transformedArray = datesArray.map(item => ({
            when: item.when,
            amount: item.amountMonthly,
          }));
        } else {
          transformedArray = datesArray.map(item => ({
            when: item.when,
            amount: item.amountYearly,
          }));
        }

        return transformedArray;
      }

      showValue();
    }

    // Add event listener for the Select2 select event
    $('.wi-calculator__select').on('select2:select', function(e) {
      calculateIfValid(); // Only calculate if valid
    });

    function checkAmountNumber() {
      let currencyValues = "GEL";
      for (const radio of currencyRadios) {
        if (radio.checked) {
          currencyValues = radio.value;
          break;
        }
      }
    
      const { min, max } = getValidRangeForCurrency(currencyValues);
      
      const potentialAmountNumber = document.getElementById("potential-amountNumber");
      
      if (isAmountValid()) {
        calculate(); // Call calculate() if amount is valid
        potentialAmountNumber.style.display = "none";
        amountNumber.classList.remove("wi-calculator__wrong-input");
      } else {
        potentialAmountNumber.style.display = "block";
        amountNumber.classList.add("wi-calculator__wrong-input");
    
        
      // Set the specific error message for each currency
      if (currencyValues === "GEL") {
        potentialAmountNumber.textContent = `მინ. თანხა - 100 000 ლარი, მაქს. - 3 000 000 ლარი`;
      } else if (currencyValues === "USD") {
        potentialAmountNumber.textContent = `მინ. თანხა - 100 000 ლარი, მაქს. - 3 000 000 ლარი  (ექვივალენტი დოლარში)`;
      } else if (currencyValues === "EUR") {
        potentialAmountNumber.textContent = `მინ. თანხა - 100 000 ლარი, მაქს. - 3 000 000 ლარი  (ექვივალენტი ევროში)`;
      }
    
        // Clear the output fields
        moneyAfter.textContent = "0.00";      
        benefit.textContent = "0.00"; 
        effectivePercent.textContent = "0 %";
        percentContainer.textContent = "0 %";          
      }
    }
    
    // Call checkAmountNumber on input event to validate amountNumber
    amountNumber.addEventListener('input', checkAmountNumber);

    // Call checkAmountNumber when currency radio buttons change
    currencyRadios.forEach(radio => radio.addEventListener('change', checkAmountNumber));

    // Call calculateIfValid when currency radio buttons change
    currencyRadios.forEach(radio => radio.addEventListener('change', calculateIfValid));

    // Call calculate() on page load to initialize values based on amountNumber validity
    calculateIfValid();
  }
});

/*
 * Yoast SEO Block
 */
document.addEventListener('DOMContentLoaded', function(e) {
  const faqSections = document.querySelectorAll('.schema-faq-section');
  const faqQuestions = document.querySelectorAll('.schema-faq-question');

  faqQuestions.forEach(function (faqQuestion, index) {
      faqQuestion.addEventListener('click', function () {
          console.log('Question clicked:', index);
          const currentSection = faqSections[index];
          const answer = currentSection.querySelector('.schema-faq-answer');

          if (currentSection) {
              currentSection.classList.toggle('schema-faq-section-active');

              if (currentSection.classList.contains('schema-faq-section-active')) {
                  // Set max-height to scrollHeight for expansion
                  answer.style.maxHeight = answer.scrollHeight + 'px';
                  answer.style.opacity = 1; // Set opacity to 1 when expanded
              } else {
                  // Reset max-height to 0 for collapsing
                  answer.style.maxHeight = 0;
                  answer.style.opacity = 0; // Set opacity to 0 when collapsed
              }
          }
      });
  });
});